import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../api.js";
import { useAuth } from "../auth.js";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [stage, setStage] = useState<"email" | "code">("email");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: string } };
  const after = location.state?.from ?? "/";

  async function onRequestCode(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.requestCode(email.trim());
      setInfo("ログインコードを送信しました。届いていればメールを確認してください。");
      setStage("code");
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  async function onVerify(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.verify(email.trim(), code.trim());
      await refresh();
      navigate(after, { replace: true });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section data-testid="login-page" style={{ maxWidth: 400, margin: "40px auto" }}>
      <h1>ログイン</h1>
      {info && <div className="empty-state" style={{ padding: 8 }}>{info}</div>}
      {error && <div className="error-banner" data-testid="login-error">{error}</div>}
      {stage === "email" ? (
        <form className="row" onSubmit={onRequestCode}>
          <label className="field">
            <span>メールアドレス</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              data-testid="email-input"
            />
          </label>
          <button type="submit" className="btn" disabled={submitting} data-testid="request-code-btn">
            {submitting ? "送信中…" : "コードを送信"}
          </button>
        </form>
      ) : (
        <form className="row" onSubmit={onVerify}>
          <div className="empty-state" style={{ padding: 8 }}>
            送信先: <strong>{email}</strong>{" "}
            <button
              type="button"
              className="btn secondary"
              style={{ marginLeft: 8 }}
              onClick={() => {
                setStage("email");
                setCode("");
                setInfo(null);
                setError(null);
              }}
            >
              変更
            </button>
          </div>
          <label className="field">
            <span>6 桁のコード</span>
            <input
              type="text"
              inputMode="numeric"
              maxLength={6}
              pattern="\d{6}"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              required
              autoFocus
              data-testid="code-input"
            />
          </label>
          <button type="submit" className="btn" disabled={submitting} data-testid="verify-btn">
            {submitting ? "確認中…" : "ログイン"}
          </button>
        </form>
      )}
    </section>
  );
}
